<template>
  <div class="day">
    <div class="header">
      {{ formatDay }}
    </div>
    <div class="day-container">
      <Item
        v-for="log in data"
        :key="log.id"
        class="entry"
        :log="log"
        @deleted="onDeleted"
        @saved="$emit('saved', $event)"
      />
    </div>
    <div class="footer">
      {{ aggregateDurations | duration }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Item from './Item'
import { formatStringDuration } from '../../filters/Duration'
import { formatLooseDate } from '../../filters/Time'

export default {
  components: {
    Item,
  },
  filters: {
    'duration': formatStringDuration
  },
  props: {
    day: {
      type: Object,
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      qryId: null
    }
  },
  computed: {
    formatDay () {
      return formatLooseDate(this.day)
    },
    aggregateDurations () {
      var taskdurations = this.data.map((item) => item.taskduration)
      return taskdurations.reduce((a, b) => a + b, 0)
    },
    ...mapGetters({
      filterProjects: 'selectedProjects',
      filterEmployees: 'selectedEmployees',
      filterTenant: 'selectedTenant'
    })
  },
  methods: {
    onDeleted (log) {
      this.$emit("deleted", log)
    },
  },
}
</script>

<style lang="scss" scoped>
.day {
  flex-grow: 1;
  background-color: #f8f9fa;
  border: 1px solid #e5e5e5;
  border-radius: 3px;
  position: relative;
  padding: 0 0 24px 0;
  min-width: 200px;
  font-size: 13px;

  @media screen and (min-width: 1100px) {
    min-height: calc(99vh - 400px);
  }

  .day-container {
    height: calc(100% - 25px);
  }
  .header {
    padding: 2px 3px 2px 3px;
    border-bottom: 1px solid #e5e5e5;
    font-weight: bold;
    .loading {
      margin: 2px 2px 0 0;
      float: right;
      opacity: .5;
    }
  }
  .footer {
    position: absolute;
    bottom: 0;
    border-top: 1px solid #e5e5e5;
    width: 100%;
    text-align: right;
    padding: 0 5px 0 0;
  }
  .entry:last-child {
    margin-bottom: 6px;
  }
}
</style>
